import styled from 'styled-components';
import Title from '../../../../components/Title';

let cloudyBlue = '#bbc3d3';

export const VRM = styled(Title)`
  border: 1px solid ${cloudyBlue};
  padding: 2px 15px;
  border-radius: 2px;
  text-align: center;
`
export const SmallTitle = styled(Title)`
  font-size: 15px;
`

export const RightPanel = styled.div`
  display: flex;

  span.textblock {
    margin-left: 8px;
    max-width: 200px;
  }

  .odometer {
    font-family: 'Courier New', Courier, monospace;
    font-weight: 700;
    display: inline-flex;
    letter-spacing: 0.3em;
    padding: 0 0.2em;
    color: white;
    background-color: #333;
    background-image: linear-gradient(to bottom, #000, #666, #000);
  }
`;

export const MOTPanel = styled.div`
  display: flex;
  padding: 7px;
  &.mot_expired{
    background-color: rgba(255, 88, 87, 0.08);
  }
  &.mot_expires_soon{
    background-color: rgba(43, 155, 255, 0.1);
  }
  &.mot_due{
    background-color: rgba(145, 152, 163, 0.1);
  }
  span{
    margin-left: 8px;
    max-width: 190px;
    .mot_expired{
      color: #ff5857;
      font-weight: 600;
      max-width: 150px;
    }
    .mot_expires_soon{
      color: #2b9bff;
    }
    .mot_due{
      color: #9198a4;
    }
  }
`;

export const LeftPanel = styled.div`
  display: flex;
  flex-direction: column;

  >:first-child {
    margin-bottom: 5px;
  }
`

export const LogoImg = styled.img`
  align-self: flex-start;
  max-width: 56px;
  max-height: 2em;
  width: auto;
  height: auto;
  margin: 0;
`;
